import React, { useEffect } from 'react';
import { Shield, Lock, Eye, FileText, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Privacy Policy | Omkar More";
  }, []);

  const sections = [
    {
      icon: <Eye size={20} />,
      title: "Data Collection",
      content: "We collect information you provide directly via contact forms, including your name, email address, and project details. Technical data such as IP addresses and browser types may be collected via cookies for site analytics."
    },
    {
      icon: <Lock size={20} />,
      title: "Data Usage",
      content: "Your information is used strictly to respond to inquiries, provide NDT/IT services, and improve user experience. We do not sell or lease your personal data to third parties."
    },
    {
      icon: <Shield size={20} />,
      title: "Data Security",
      content: "We implement industrial-standard security protocols to protect your data. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security."
    },
    {
      icon: <FileText size={20} />,
      title: "Your Rights",
      content: "You have the right to request access to the data we hold about you or request its deletion. For any privacy-related concerns, please contact us via the official email provided."
    }
  ];

  return (
    <div className="bg-slate-50 min-h-screen pt-32 pb-20 px-6">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <Link to="/" className="inline-flex items-center gap-2 text-slate-400 hover:text-cyan-600 mb-12 transition-colors group">
          <ArrowLeft size={16} className="group-hover:-translate-x-1 transition-transform" />
          <span className="text-[10px] font-black uppercase tracking-widest">Return to Home</span>
        </Link>

        <header className="mb-16">
          <h1 className="text-4xl md:text-6xl font-black text-slate-950 tracking-tighter uppercase mb-4">
            Privacy <span className="text-cyan-600 italic font-light">Policy</span>
          </h1>
          <p className="text-slate-500 font-mono text-xs tracking-widest uppercase">
            Last Updated: January 2026 // Revision 1.0
          </p>
        </header>

        {/* Content Grid */}
        <div className="grid gap-8">
          {sections.map((section, idx) => (
            <div key={idx} className="bg-white border border-slate-200 p-8 rounded-[2rem] shadow-sm">
              <div className="flex items-start gap-6">
                <div className="p-4 bg-slate-50 rounded-2xl text-cyan-600">
                  {section.icon}
                </div>
                <div>
                  <h2 className="text-xl font-black text-slate-950 uppercase tracking-tight mb-3">
                    {section.title}
                  </h2>
                  <p className="text-slate-600 leading-relaxed text-sm md:text-base">
                    {section.content}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer Note */}
        <div className="mt-16 p-8 bg-slate-950 rounded-[2rem] text-center">
          <p className="text-slate-400 text-sm mb-6">
            Have questions about your data? Reach out directly.
          </p>
          <a href="mailto:moreomkar972@gmail.com" className="text-white font-black text-xs uppercase tracking-[0.2em] hover:text-cyan-500 transition-colors">
            moreomkar972@gmail.com
          </a>
        </div>
      </div>
    </div>
  );
}